/**
 * Utility function to combine classnames conditionally
 * Similar to clsx or classnames libraries
 */
export function cn(...classes: (string | undefined | null | false)[]): string {
  return classes
    .filter((c) => typeof c === 'string')
    .join(' ')
    .replace(/\s+/g, ' ')
    .trim();
}
